import axios from 'axios';
import { useMainStore } from '../store/index';

const oldDSApi = axios.create({ baseURL: process.env.VUE_APP_DS_API_URL });
const offeringsApi = axios.create({ baseURL: process.env.VUE_APP_DS_API_OFFERINGS_URL });
const translationsAPI = axios.create({ baseURL: process.env.VUE_APP_DS_API_TRANSLATIONS_URL });
const usersAPI = axios.create({ baseURL: process.env.VUE_APP_DS_API_USERS_URL });
const configurationsAPI = axios.create({ baseURL: process.env.VUE_APP_DS_API_CONFIGURATIONS_URL });

const getFromStore = (prop) => {
  const store = useMainStore();
  return store[prop];
};

[oldDSApi, offeringsApi, translationsAPI, usersAPI, configurationsAPI].forEach(axiosApi => {
  axiosApi.interceptors.request.use((config) => {
    const store = useMainStore();
    config.headers.Authorization = store.token;
    return config;
  }, (error) => Promise.reject(error));
});

const getActiveOffersSummary = async (offeringId, market = getFromStore('market')) => offeringsApi.get(`/v1/markets/${market}/offers/active/summary`, { params: { offeringId } });
const getOfferImageLinks = async (market = getFromStore('market'), offerId, queryParams) => offeringsApi.get(`v1/markets/${market}/offers/${offerId}/image-links`, { params: queryParams });
const getConfigurationV2 = async (market = getFromStore('market'), offerId = getFromStore('offerId')) => offeringsApi.get(`/v2/markets/${market}/offers/${offerId}/configuration`);
const getImages = async (specificationImpacts, offerId = getFromStore('offerId'), market = getFromStore('market'), queryParams = {}) => oldDSApi.post(`/v1/markets/${market}/offers/${offerId}/images`, specificationImpacts, { params: queryParams });
const getSpecification = async (offerId = getFromStore('offerId'), market = getFromStore('market')) => oldDSApi.get(`/v1/markets/${market}/offers/${offerId}/specification`);
const getFpcCodeTranslations = async (fpcCodes, locale) => {
  // The API only handles 100 codes per request
  let requests = [];
  for (let i = 0; i < fpcCodes?.length; i += 100) {
    requests.push(
      oldDSApi.post('/v1/fpcCodes/translations', { fpcCodes: fpcCodes.slice(i, i + 100), locale }),
    );
  }

  const responses = await Promise.all(requests);
  const results = responses.reduce((list, response) => [...list, ...response.data], []);
  return Promise.resolve({ data: results });
};
const getOfferIds = async (market = getFromStore('market')) => oldDSApi.get(`/v1/markets/${market}/user/offers/ids`);
const finalizeOffer = async (data, offerId = getFromStore('offerId'), market = getFromStore('market')) => offeringsApi.post(`/v1/markets/${market}/offers/${offerId}/finalize`, data);
const approveRegulations = async (offerId = getFromStore('offerId')) => oldDSApi.put(`/v1/offers/${offerId}/approve/regulations`);
const getOfferStatus = async (offerId = getFromStore('offerId')) => oldDSApi.get(`/v1/offers/${offerId}/status`);
// const getTranslations = async (locale) => oldDSApi.get(`/v1/translations/${locale}`); // not in use
const requestSupport = async (phone, email, offerId = getFromStore('offerId'), market = getFromStore('market')) => oldDSApi.post(`/v1/markets/${market}/offers/${offerId}/support`, { email, phone });
const updateSelections = async (selections, offerId = getFromStore('offerId')) => oldDSApi.post(`/v1/offers/${offerId}/selections`, selections);
const getUserMetadata = async (federationUserAccountId) => usersAPI.get(`/v1/users/${federationUserAccountId}/metadata`);
const removeUserResetPasswordMapping = async (federationUserAccountId) => oldDSApi.delete(`/v1/users/${federationUserAccountId}/resetpasswordmapping`);
const addTrackingEvent = async (evetData, tid) => oldDSApi.put(`/v1/tracking-events/${tid}/event`, evetData);
const addTrackingEventByOffer = async (evetData, offerId = getFromStore('offerId')) => oldDSApi.put(`/v1/offers/${offerId}/tracking-events`, evetData);
const addOfferComment = async (offerComment, offerId = getFromStore('offerId'), market = getFromStore('market')) => oldDSApi.post(`/v1/markets/${market}/offers/${offerId}/comments`, offerComment);
const getOfferComments = async (store = useMainStore()) => oldDSApi.get(`/v1/offers/comments`, { params: { offerId: getFromStore('offerId'), ...(!store.isSalesman ? { federationUserAccountId: store.federationUserAccountId } : {}) } });
const getSalesmanOfferings = async () => oldDSApi.get(`/v1/offerings-salesman`);
const checkFeatureToggle = async (featureKey, market = getFromStore('market')) => configurationsAPI.get(`/v1/markets/${market}/feature-toggle/${featureKey}/check`);
const getAppConfiguration = async (configKey, market = getFromStore('market')) => oldDSApi.get(`/v1/markets/${market}/app-configuration/${configKey}`);
const getMarketTranslations = async (market, locale) => translationsAPI.get(`/v1/markets/${market}/translations/${locale}`);

export {
  getConfigurationV2,
  getImages,
  getSpecification,
  getFpcCodeTranslations,
  getOfferIds,
  getOfferStatus,
  finalizeOffer,
  // getTranslations, // not in use
  requestSupport,
  approveRegulations,
  updateSelections,
  getUserMetadata,
  removeUserResetPasswordMapping,
  addTrackingEvent,
  addTrackingEventByOffer,
  addOfferComment,
  getOfferComments,
  getSalesmanOfferings,
  checkFeatureToggle,
  getAppConfiguration,
  getMarketTranslations,
  getActiveOffersSummary,
  getOfferImageLinks,
};
